import { ref } from 'vue'
import { invoke } from '@tauri-apps/api/core'

export interface UpdateInfo {
  available: boolean
  version: string | null
  notes: string | null
  date: string | null
}

/**
 * 自动更新 Hook
 */
export function useUpdater() {
  const isChecking = ref(false)
  const isUpdating = ref(false)
  const updateInfo = ref<UpdateInfo | null>(null)
  const error = ref<string | null>(null)

  /**
   * 检查更新
   */
  async function checkUpdate(): Promise<UpdateInfo | null> {
    // 检查是否在 Tauri 环境中
    if (typeof window === 'undefined' || !('__TAURI__' in window)) {
      console.log('Not in Tauri environment, skipping update check')
      return null
    }

    isChecking.value = true
    error.value = null

    try {
      const info = await invoke<UpdateInfo>('check_update')
      updateInfo.value = info
      return info
    } catch (e) {
      error.value = String(e)
      console.error('Failed to check update:', e)
      return null
    } finally {
      isChecking.value = false
    }
  }

  /**
   * 安装更新
   */
  async function installUpdate(): Promise<boolean> {
    if (typeof window === 'undefined' || !('__TAURI__' in window)) {
      console.log('Not in Tauri environment, skipping update install')
      return false
    }

    isUpdating.value = true
    error.value = null

    try {
      await invoke('install_update')
      return true
    } catch (e) {
      error.value = String(e)
      console.error('Failed to install update:', e)
      return false
    } finally {
      isUpdating.value = false
    }
  }

  return {
    isChecking,
    isUpdating,
    updateInfo,
    error,
    checkUpdate,
    installUpdate,
  }
}
